import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  itemRoot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  itemContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minWidth: 0
  },
  itemTextContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5)
  },
  itemUserRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  itemNegativeMargin: {
    marginTop: theme.spacing(-0.25)
  },
  itemDelaStarIcon: {
    fill: theme.palette.Dela.darkIcon,
    fontSize: theme.spacing(2.25)
  },
  itemDropdownIcon: {
    color: theme.palette.text.secondary
  },
  itemErrorIcon: {
    fontSize: theme.spacing(2.5)
  },
  proposeButtonIcon: {
    fill: theme.palette.primary.main,
    marginLeft: theme.spacing(1)
  },
  acceptButtonIcon: {
    fill: theme.palette.success.main,
    marginLeft: theme.spacing(1)
  },
  itemButtonShadow: {
    display: 'flex',
    borderRadius: theme.spacing(5),
    '&:hover': { boxShadow: '0px 0px 0px 10px rgba(38,210,147,0.04)' },
    height: 'fit-content'
  }
}));

export default useStyles;
